import { DECLARATIONS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const DeclarationsExporter = createExporter(`document_${DECLARATIONS}.xlsx`,
    [
        { key: "nameBg", label: "име на български" },
        { key: "nameBg", label: "име на английски" }
    ],
    (record) => ({
       ...record
    }),
); 